import React from 'react'
import newsydoozyLogo from '../images/logo1.png'
import pranavImage from '../images/pranav.JPG'
import MadeWithLove from './MadeWithLove';

const NewsyDoozy = (props) => {
    return (
        <>
            <div className="container text-center my-3">
                <img src={newsydoozyLogo} alt="NewsyDoozy" width={"1300px"} height={"270px"} style={{ border: `10px solid ${props.borderColor}` }} />
                <br /><br />
                <div className='row align-items-center'>
                    <div className='col'>
                        <img src={pranavImage} alt="Pranav Arya" width="300" height="400" style={{ border: `10px solid ${props.borderColor}` }} />
                    </div>
                    <div className='col' style={{fontSize: "18px"}} >
                        <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/pranavarya37/" target='_blank' rel="noopener noreferrer" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>@pranavarya37</a>
                        <br />
                        <br />
                        <strong>Instagram:</strong> <a href="https://www.instagram.com/pranavarya37" target='_blank' rel="noopener noreferrer" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>@pranavarya37</a>
                        <br />
                        <br />
                        <strong>Twitter:</strong> <a href="https://www.twitter.com/pranavarya37" target='_blank' rel="noopener noreferrer" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>@pranavarya37</a>
                        <br />
                        <br />
                        <strong>Github:</strong> <a href="https://www.github.com/pranavarya37" target='_blank' rel="noopener noreferrer" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>@pranavarya37</a>
                        <br />
                        <br />
                        <strong>Threads:</strong> <a href="https://www.threads.net/@pranavarya37" target='_blank' rel="noopener noreferrer" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>@pranavarya37</a>
                        <br />
                        <br />
                        <strong>Email:</strong> <a href="mailto:pranavarya2799@gmail.com" style={{color: props.mode === "primary"?"#f608a8":"#0fe3c3"}}>pranavarya2799@gmail.com</a>
                        <div className="my-3" style={{
                            fontSize: "20px",
                            color: "#fff",
                            textAlign: "center",
                            padding: "10px",
                            bottom: "10px",
                            backgroundColor: props.mode === "primary" ? "#007BFF" : "#333",
                            zIndex: "9999",
                            margin: "auto",
                            left: "0",
                            right: "0"
                        }}>
                            <MadeWithLove mode={props.mode} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewsyDoozy


